import { useLocalStorage } from '../../components/providers/local-storage-provider/local-storage.context';
import { USER_PERMISSIONS } from '../../store/modules/user/user.constants';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const checkPermission = (value: string, type: string) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const localStorageService = useLocalStorage();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const permissions: { [key: string]: any } | null = localStorageService.get(USER_PERMISSIONS);
  return permissions && permissions[value] && permissions[value][type];
  return true;
};
export default checkPermission;
